export default __webpack_public_path__ + "static/zermatt-switzerland-6e8cc36608f5a155d300728f238c7491.jpg";